import * as crop from './crop';
import * as helper from './helper';
import * as addFileHelper from './add-file-helper';

function init(job) {
    var pixConfig = {
        ui: {
            nav: {
                position: 'top',
                replaceDefault: false,
                items: [
                    {
                        name: 'add',
                        icon: 'layers',
                        action: function () {
                            addFileHelper.openAddFileMenu();
                        },
                    },
                ],
            },
        },
        onLoad: function () {
            crop.customCropSetup();
            addFileHelper.init();

            $('.apply-button').click(function () {
                window.pixApplied = true;
            });

            helper.hideLoadingAnimation();
        },
    };

    function waitForPixie() {
        if (typeof Pixie === 'undefined') {
            setTimeout(waitForPixie, 500);

            return;
        }

        helper.initPixie(job, pixConfig);
    }

    waitForPixie();
}

export { init };
